const comments = [
  {
    name: '影迷小李',
    time: '2小时前',
    rating: 5,
    text: '太喜欢8848影院了！片源全、画质好，关键是完全免费。以前在其他平台看个电影还要充会员，现在直接打开就能看，方便太多了。推荐给了身边所有朋友！',
    movie: '在看《星际迷航：新纪元》',
  },
  {
    name: '每日观影',
    time: '5小时前',
    rating: 5,
    text: '作为一个重度电影爱好者，8848影院真的是我每天必逛的地方。片库更新速度很快，分类也很清晰，找片子特别方便。最近上线的经典修复系列质量很高，大赞！',
    movie: '在看《霸王别姬》数字重制版',
  },
  {
    name: '周末影迷',
    time: '昨天',
    rating: 4,
    text: '用了快半年了，整体体验很棒。最喜欢的是每天更新的快讯板块，能看到最新上线的电影资讯。希望后续能增加一些影评和讨论功能，让影迷之间有更多交流。',
    movie: '在看喜剧专题',
  },
  {
    name: '电影发烧友小张',
    time: '昨天',
    rating: 5,
    text: '港产动作片合集简直是我的青春回忆！成龙的醉拳系列、李连杰的黄飞鸿，高清画质重温经典，每一帧都是满满的感动。8848影院真的懂影迷想要什么。',
    movie: '在看港产动作经典合集',
  },
  {
    name: '宅家观影达人',
    time: '2天前',
    rating: 5,
    text: '手机端体验出乎意料地好，界面简洁流畅，投屏功能也很方便。周末躺床上用手机投屏到电视看大片，简直不要太惬意。给技术团队点赞！',
    movie: '在看动作猛片专题',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-300 bg-primary-500/10 rounded-full mb-4">
            观众热评
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-3">
            观众热评
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-[560px] mx-auto">
            听听影迷们怎么说，加入8848影院的观影大家庭
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {comments.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-200/70 border border-background-300/40 p-5 md:p-6 transition-all duration-300 hover:border-accent-500/20"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-accent-500/30 to-primary-500/30 flex items-center justify-center">
                  <span className="text-sm font-bold text-accent-300">
                    {item.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-300">{item.name}</div>
                  <div className="text-xs text-foreground-600">{item.time}</div>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-2">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-xs ${i < item.rating ? 'ri-star-fill text-primary-400' : 'ri-star-fill text-foreground-700'}`}
                  ></i>
                ))}
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-3 line-clamp-4">
                {item.text}
              </p>
              <div className="flex items-center gap-1.5 text-xs text-foreground-600">
                <i className="ri-movie-2-line"></i>
                <span>{item.movie}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}